import React from "react";
import { Image, Platform, TouchableOpacity, View } from 'react-native';
import ThemeProvider from "@voltmoney/theme";
import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens } from "@voltmoney/schema";
import { Icon } from "../icon/Icon";
import { Typography } from "../typography/Typography";
import { Divider } from "../divider/Divider";
import { getParameters, isFromAndroidWebview } from "../pages/utils";
const CustomHeader = ({ hideGoBack = false, title, goBackAction, needHelpAction, triggerAction, hideNeedHelp, goBackId, needHelpId, onPress, getbgColor, isDarkMode, showNeedHelpNewArch, hideDivider, selectedBankLabel, iconImage }) => {
    const theme = ThemeProvider.getTheme();
    let bgColor = theme.colors[ColorTokens.Primary_100];
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = getParameters(url);
    const platformCode = params?.platform || '';
    const isFromJsSdk = params?.isFromJsSDK || false;
    const hideNeedHelpForTata = platformCode === "TATADIGITAL" && isFromJsSdk;
    return (React.createElement(View, { style: {
            paddingTop: Platform.OS === "ios" ? 0 : 16,
            justifyContent: 'center',
            marginTop: Platform.OS === 'ios' ? 32 : 0,
            backgroundColor: isDarkMode ? '#0D141F' : 'white',
        } },
        React.createElement(View, { style: {
                backgroundColor: theme.colors[bgColor],
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingHorizontal: 16,
                alignItems: 'center',
                marginTop: Platform.OS === "ios" ? 20 : 0
            } },
            React.createElement(View, { style: { flexDirection: 'row' }, nativeID: goBackAction?.payload?.id ? goBackAction?.payload?.id : goBackId },
                iconImage,
                !hideGoBack &&
                    React.createElement(TouchableOpacity, { hitSlop: { top: 48, bottom: 48, left: 48, right: 48 }, onPress: () => {
                            onPress && onPress();
                            goBackAction && triggerAction({
                                ...goBackAction,
                                payload: {
                                    selectedBankLabel,
                                    ...goBackAction.payload
                                }
                            });
                        } },
                        React.createElement(Icon, { name: IconTokens.BackArrowIcon, size: IconSizeTokens.XL, color: isDarkMode ? ColorTokens.White : ColorTokens.Black })),
                title &&
                    React.createElement(View, { style: {
                            marginLeft: 8
                        } },
                        React.createElement(Typography, { label: title, fontWeight: '500', fontSize: FontSizeTokens.SM, lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))),
            !hideNeedHelp && !hideNeedHelpForTata &&
                React.createElement(View, { nativeID: needHelpAction?.payload?.id ? needHelpAction?.payload?.id : needHelpId, style: {
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        alignSelf: 'center'
                    } },
                    React.createElement(TouchableOpacity, { activeOpacity: 1, style: {
                            backgroundColor: isDarkMode ? "#48536B" : '#F3F5FC',
                            borderRadius: 24,
                            height: 24,
                            paddingVertical: 3,
                            paddingHorizontal: 8,
                            flexDirection: 'row'
                        }, hitSlop: { top: 24, bottom: 24, left: 24, right: 24 }, onPress: () => {
                            if (Platform.OS === 'web' && params.platform === "TATADIGITAL" && !params?.isFromJsSDK) {
                                if (isFromAndroidWebview()) {
                                    window.open("FAQ_CLICKED", "_parent");
                                }
                                //@ts-ignore
                                window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("FAQ");
                                //@ts-ignore
                                // window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("FAQ_CLICKED");            
                            }
                            else {
                                if (!showNeedHelpNewArch)
                                    triggerAction({
                                        ...needHelpAction
                                    });
                                else
                                    needHelpAction();
                            }
                        } },
                        platformCode === "JUPITER" || (platformCode === "TATADIGITAL" && isFromJsSdk) ? React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/contact_us.png" }, style: { width: 15, height: 17 }, resizeMode: 'contain' }) :
                            React.createElement(Icon, { name: IconTokens.Whatsapp, size: IconSizeTokens.MD }),
                        React.createElement(View, { style: {
                                marginLeft: 4
                            } },
                            React.createElement(Typography, { label: 'NEED HELP?', fontSize: FontSizeTokens.XXS, fontWeight: "600", lineHeight: 16, color: isDarkMode ? ColorTokens.White : ColorTokens.Primary_100, fontFamily: FontFamilyTokens.Inter }))))),
        React.createElement(View, { style: {
                marginTop: 16,
                ...Platform.OS !== 'web' && {
                    marginHorizontal: -16
                }
            } }, hideDivider ? React.createElement(React.Fragment, null, " ") : React.createElement(Divider, { size: DividerSizeTokens.SM, color: isDarkMode ? ColorTokens.DARK_MODE_DIVIDER : ColorTokens.Grey_Chalk }))));
};
export default (CustomHeader);
